/* for app analysis module */
export const COUNTRY_SELECTION = "COUNTRY_SELECTION";
export const DURATION_SELECTION = "DURATION_SELECTION";
export const WEB_SOURCE_SELECTION = "WEB_SOURCE_SELECTION";
export const EDUCATIONAL_FILTER_WAS_PRESENTED = "EDUCATIONAL_FILTER_WAS_PRESENTED";
/* for website analysis module */
export const IS_NEW_SESSION = "IS_NEW_SESSION";
export const DIGITAL_SUITE_COUNTRY_SELECTION = "DIGITAL_SUITE_COUNTRY_SELECTION";
export const DIGITAL_SUITE_DURATION_SELECTION = "DIGITAL_SUITE_DURATION_SELECTION";
export const DIGITAL_SUITE_WEB_SOURCE_SELECTION = "DIGITAL_SUITE_WEB_SOURCE_SELECTION";
export const DIGITAL_SUITE_OPEN_COUNTRY_SELECTION = "DIGITAL_SUITE_OPEN_COUNTRY_SELECTION";
